<template>
  <v-container
    fluid
    class="white-background main-create-page mt-0"
    :class="[customClass]"
  >
    <div class="p-0 pb-0">
      <v-row>
        <v-col cols="12" md="12" class="pt-0" :class="headerLeftClass">
          <slot name="header-title"></slot>
        </v-col>
        <div
          class="pt text-center px-0 py-2"
          :class="headerRightClass"
          style="
            bottom: -5px;
            z-index: 15;
            background-color: #f4f4f4;
            max-width: calc(100% - 65px);
            position: fixed;
            width: 100%;
            right: 0px;
          "
        >
          <slot name="header-action"></slot>
        </div>
      </v-row>
    </div>
    <slot name="body"></slot>
    <slot name="barcode-setting"></slot>
    <slot name="extra"></slot>
    <template v-if="hasChanges">
      <!-- <PreventUnload :when="hasChanges" /> -->
    </template>
    <Dialog :commonDialog="routePreventDialog" :dialogWidth="600">
      <template v-slot:body>
        <v-layout>
          <v-flex md2 class="text-center">
            <!--begin::Svg Icon-->
            <inline-svg
              width="50"
              :src="$assetURL('media/custom-svg/attention-circle.svg')"
            />
            <!--end::Svg Icon-->
          </v-flex>
          <v-flex md10>
            <p class="font-weight-700">
              Are you sure you want to leave this page?
            </p>
            <v-layout>
              <v-flex>
                <v-btn
                  depressed
                  class="mr-2 custom-grey-border custom-bold-button white--text"
                  color="cyan"
                  small
                  v-on:click="stayOnPage"
                >
                  Stay on this page
                </v-btn>
                <v-btn
                  depressed
                  class="mx-2 custom-grey-border custom-bold-button"
                  small
                  v-on:click="leavePage"
                >
                  Leave this page
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </Dialog>
  </v-container>
</template>

<script>
// import PreventUnload from "vue-prevent-unload";
import Dialog from "@/view/pages/partials/Dialog";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";

export default {
  props: {
    customClass: {
      type: String,
      default: null,
    },
    headerLeftClass: {
      type: String,
      default: null,
    },
    headerRightClass: {
      type: String,
      default: null,
    },
    routePreventDialog: {
      type: Boolean,
      default: false,
    },
    hasChanges: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    stayOnPage() {
      PreventDialogEventBus.$emit("stay-on-page", true);
    },
    leavePage() {
      PreventDialogEventBus.$emit("leave-page", true);
    },
  },
  components: {
    // PreventUnload,
    Dialog,
  },
};
</script>
